import classNames from 'classnames';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';

import { IScrollableWithShadowProps } from '@/shared/components/atoms/ScrollableWithShadow/IScrollableWithShadow';

const ScrollableWithShadow: React.FC<IScrollableWithShadowProps> = ({
  children,
  className,
  maxHeight = 'max-h-520',
  bgColor = 'white',
}) => {
  const [isShadowVisible, setIsShadowVisible] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  const updateShadowVisibility = () => {
    const scrollElement = scrollRef?.current;
    if (!scrollElement) return;

    const { scrollTop, scrollHeight, clientHeight } = scrollElement;
    setIsShadowVisible(Math.ceil(scrollTop + clientHeight) < scrollHeight);
  };

  // Use `useLayoutEffect` to ensure shadow visibility is set synchronously after children change
  useLayoutEffect(() => {
    updateShadowVisibility();
  }, [children]);

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', updateShadowVisibility);
      return () =>
        scrollElement.removeEventListener('scroll', updateShadowVisibility);
    }
  }, []);

  return (
    <div className={classNames('relative', className)}>
      <div
        ref={scrollRef}
        className={classNames(
          'overflow-auto scrollbar-none',
          'min-h-[200px]',
          maxHeight
        )}
      >
        {children}
      </div>
      {isShadowVisible && (
        <div
          className='pointer-events-none absolute inset-x-0 bottom-0 h-100'
          style={{
            background:
              bgColor === 'light-grey'
                ? 'linear-gradient(180deg, rgba(252, 252, 252, 0) 0%, #F3F4F6 100%)'
                : 'linear-gradient(180deg, rgba(252, 252, 252, 0) 0%, #FCFCFC 100%)',
          }}
        />
      )}
    </div>
  );
};

export default ScrollableWithShadow;
